import { FC, SVGAttributes } from 'react';

import Reserve from '@/assets/icons/Reserve';

import styles from './Reserve.module.css';

const ReserveIcon: FC<SVGAttributes<SVGSVGElement>> = ({ ...iconProps }) => (
  <Reserve className={styles.reserveIconStyle} {...iconProps} />
);
export default ReserveIcon;
